<template>
  <div class="widget">
    <div class="title">{{ $t('pages_home_calendar_001') }}</div>
    <div class="content-area">
      <div v-if="holidayNotify.length === 0" class="empty">{{ $t('pages_home_calendar_003') }}</div>
      <div v-else class="calendar-content">
        <div class="scroll-container">
          <div class="scroll-text">{{ holidayNotify }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
// import { useStore } from 'vuex'
export default defineComponent({
  name: 'Todo',
  props: {
    holidayNotify: {
      type: String,
      required: true
    }
  }
})
</script>

<style lang="less" scoped>
.content-area {
  width: 100%;
  display: block;
  border-radius: 8px;
  border: solid 1px #E5E9F2;
  margin-top: 20px;
  .empty {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #A0A7B8;
  }
  .calendar-content {
    padding: 20px;
    font-size: 14px;
    color: #333;
    .scroll-container {
      height: 50px; /* Adjust height as needed */
      overflow: hidden;
      position: relative;
    }
    .scroll-text {
      position: absolute;
      width: 100%;
      animation: scroll-up 10s linear infinite;
    }
  }
}

@keyframes scroll-up {
  0% {
    top: 100%;
  }
  100% {
    top: -100%;
  }
}
</style>
